export default "__VITE_ASSET__aq1T8xAe__"